export default __webpack_public_path__ + "static/media/burger.ccc4439f.jpg";